<template>
  <section>
    <bread-crumb :routeName="'Contact'"></bread-crumb>
    <loading v-if="isLoading"></loading>
    <div class="columns is-marginless is-paddingless is-gapless">
      <div
        class="column is-7 m-b-10"
        :class="{ 'm-r-10': $mq.resize && $mq.above($mv.tablet) }"
      >
        <card
          :red="true"
          :background="egypt_image"
          :isButtonHidden="true"
          :html="true"
          :email="egypt_email"
          :subtitle="egypt"
          title="EGYPT"
          height="70vh"
        ></card>
      </div>
      <div class="column is-5 m-b-10">
        <card
          :red="true"
          :background="UAE_image"
          :isButtonHidden="true"
          :html="true"
          :email="UAE_email"
          :subtitle="UAE"
          title="UAE"
          height="70vh"
        ></card>
      </div>
    </div>
    <div class="columns is-marginless is-paddingless is-gapless">
      <div
        class="column is-5 m-b-10"
        :class="{ 'm-r-10': $mq.resize && $mq.above($mv.tablet) }"
      >
        <card
          :red="true"
          :background="USA_image"
          :isButtonHidden="true"
          :html="true"
          :email="USA_email"
          :subtitle="USA"
          title="USA"
          height="70vh"
        ></card>
      </div>
      <div class="column is-7 m-b-10">
        <card
          :red="true"
          :background="switzerland_image"
          :isButtonHidden="true"
          :html="true"
          :email="switzerland_email"
          :subtitle="switzerland"
          title="SWITZERLAND"
          height="70vh"
        ></card>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      switzerland: "...",
      switzerland_image: "#",
      switzerland_email: "...",
      USA: "...",
      USA_email: "...",
      USA_image: "#",
      UAE: "...",
      UAE_image: "#",
      UAE_email: "...",
      egypt: "...",
      egypt_email: "...",
      egypt_image: "#",
      isLoading: false,
      loading: 0,
      loaded: 0,
    };
  },
  created() {
    this.isLoading = true;
    this.axios
      .get(
        `https://${this.baseURL()}/api/singletons/get/contact?token=8864674b01000e6d7d030ef8c41e72`
      )
      .then((data) => {
        console.log(data.data);
        this.switzerland = data.data["switzerland"];
        this.switzerland_email = data.data["switzerland_email"];
        this.USA = data.data["usa"];
        this.USA_email = data.data["usa_email"];
        this.UAE = data.data["uae"];
        this.UAE_email = data.data["uae_email"];
        this.egypt = data.data["egypt"];
        this.egypt_email = data.data["egypt_email"];
        this.switzerland_image = `https://${this.baseURL()}${
          data.data["switzerland_image"]["path"]
        }`;
        this.USA_image = `https://${this.baseURL()}${
          data.data["usa_image"]["path"]
        }`;
        this.UAE_image = `https://${this.baseURL()}${
          data.data["uae_image"]["path"]
        }`;
        this.egypt_image = `https://${this.baseURL()}${
          data.data["egypt_image"]["path"]
        }`;

        // subscribe to loading event to know how many images are loading
        this.$on("loading", () => {
          this.loading++;
        });

        // detect when loading is finished
        this.$on("loaded", () => {
          this.loaded++;
          // working dynamically regardless of how many images are on page!
          if (this.loaded === this.loading) this.isLoading = false;
        });
      });
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// contact.vue?09526722